module.exports = __webpack_public_path__ + "img/7.a1c61082.svg";